import React from "react";
import ReactQuill from "react-quill";

const modules = {
  toolbar: {
    container: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image", "blockquote", "code-block"],
      [{ align: [] }, { color: [] }, { background: [] }],
      ["clean"],
    ],
    // image upload handler (wire below if you need uploads)
    handlers: {
      /* image: yourHandler */
    },
  },
  clipboard: { matchVisual: false },
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet",
  "link",
  "image",
  "blockquote",
  "code-block",
  "align",
  "color",
  "background",
];

export const RichText = ({
  value,
  onChange,
  placeholder = "Write something…",
}) => {
  return (
    <div style={{ marginBlock: "1rem", width: "100%" }}>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
      />
    </div>
  );
};
export default RichText;
